<script setup lang="ts">
import CloseableDialog from '@/src/components/CloseableDialog.vue';
import {
  cancelNiftiImportIntent,
  confirmNiftiImportIntent,
  niftiImportDialogOpen,
  niftiImportFileName,
  niftiImportInFlight,
  niftiImportLoadingMessage,
  niftiImportShowProgress,
} from '@/src/io/import/niftiImportIntent';

function onDialogToggle(open: boolean) {
  if (!open) {
    if (niftiImportInFlight.value) {
      // Block user dismissal (X button) while import work runs.
      niftiImportDialogOpen.value = true;
      return;
    }
    cancelNiftiImportIntent();
  }
}
</script>

<template>
  <closeable-dialog
    v-model="niftiImportDialogOpen"
    max-width="480"
    :persistent="niftiImportInFlight"
    @update:model-value="onDialogToggle"
  >
    <v-card>
      <v-card-title>NIfTI import</v-card-title>

      <v-card-text v-if="niftiImportShowProgress" class="nifti-import-loading">
        <p class="mb-4">
          Importing
          <strong>{{ niftiImportFileName }}</strong>
          as a segmentation overlay...
        </p>
        <v-progress-linear indeterminate color="primary" class="mb-3" />
        <p class="text-body-2 text-medium-emphasis">
          {{ niftiImportLoadingMessage }}
        </p>
      </v-card-text>

      <template v-else>
        <v-card-text>
          <p class="mb-2">
            How should
            <strong>{{ niftiImportFileName }}</strong>
            be imported?
          </p>
          <p class="text-body-2 text-medium-emphasis">
            Choose <strong>Volume</strong> for grayscale imaging data, or
            <strong>Segmentation</strong> to overlay labelmaps on the current
            volume.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="cancelNiftiImportIntent()">
            Cancel
          </v-btn>
          <v-btn variant="text" @click="confirmNiftiImportIntent('volume')">
            Volume
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="confirmNiftiImportIntent('segmentation')"
          >
            Segmentation
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </closeable-dialog>
</template>

<style scoped>
.nifti-import-loading {
  min-height: 120px;
}
</style>
